.menu {
  display: inline flex;
  gap: .25rem;
  list-style: none;
  padding: 0;
  margin: 0;
}